import { apiClient } from '@/lib/api';
export const usersApi = {
    list: (orgId) => apiClient.get(`/sslwidewatch/userByOrg/${orgId}`),
    add: (body) => apiClient.post(`/sslwidewatch/newUser`, body),
    update: (id, body) => apiClient.put(`/sslwidewatch/updateUser/${id}`, body),
    remove: (id) => apiClient.delete(`/sslwidewatch/deleteUser/${id}`),
    activate: (body) => apiClient.post(`/sslwidewatch/activateUser`, body),
};
/** Derive a role label for display. Roles-set wins; fall back to booleans. */
export function roleLabel(u) {
    const fromSet = u.roles
        ?.map((r) => r.name)
        .filter(Boolean)
        .join(', ');
    if (fromSet)
        return fromSet;
    // userByOrg emits is* getters; signin emits the bare flags. Accept both.
    if (u.superUser ?? u.isSuperUser)
        return 'Super User';
    if (u.admin ?? u.isAdmin)
        return 'Admin';
    if (u.billingUser ?? u.isBillingUser)
        return 'Billing';
    if (u.standardUser ?? u.isStandardUser)
        return 'Standard';
    return '—';
}
